module.exports = __webpack_public_path__ + "img/bg-pic.abec3fa7.jpg";